import { parseISO } from "date-fns";

interface OrderElapsedTimeProps {
  createdAt: string;
}
const formatUtcToCST = (utcTimestamp: string): string => {
  try {
    let date: Date;

    // Handle both ISO and non-ISO date strings
    if (utcTimestamp.includes("T")) {
      // ISO format - use parseISO
      let isoString = utcTimestamp;

      // Only append "Z" if the timestamp doesn't already have timezone information
      const hasTimezone = /[+-]\d{2}:?\d{2}$|Z$/.test(utcTimestamp);

      if (!hasTimezone) {
        isoString = utcTimestamp + "Z";
      }

      date = parseISO(isoString);
    } else {
      // Non-ISO format - use Date constructor as fallback
      date = new Date(utcTimestamp);
    }

    if (isNaN(date.getTime())) {
      return utcTimestamp;
    }

    // Use built-in JavaScript timezone conversion (handles DST automatically)
    const timeZone = "America/El_Salvador";

    // Create a formatter for the date part
    const dateFormatter = new Intl.DateTimeFormat("es-SV", {
      timeZone,
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });

    // Create a formatter for the time part
    const timeFormatter = new Intl.DateTimeFormat("es-SV", {
      timeZone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Format the date and time separately for more control
    const formattedDate = dateFormatter.format(date);
    const formattedTime = timeFormatter.format(date);

    // Convert date from "dd/mm/yyyy" to "dd-mm-yyyy" format
    const dateWithDashes = formattedDate.replace(/\//g, "-");

    // Clean up the time format (remove dots from a.m./p.m.)
    const cleanTime = formattedTime.replace(
      /\s(a\.m\.|p\.m\.)/g,
      (period) => ` ${period.replace(/\./g, "")}`,
    );

    return `${dateWithDashes} ${cleanTime}`;
  } catch (error) {
    return utcTimestamp;
  }
};
export function OrderElapsedTime({ createdAt }: OrderElapsedTimeProps) {
  const createdAtElSalvador = formatUtcToCST(createdAt);

  return <span className="text-sm text-gray-600">{createdAtElSalvador}</span>;
}
